// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class BrandingRulesRequestMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_BRANDING_RULES_REQ, fieldSet);
    }
    setBrandingKey(brandingKey) {
        this.setFieldValue(FieldsFactory.FIELD_KEY, brandingKey);
    }
}
